import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';

@NgModule({
  declarations: [TermsOfUseComponent],
  imports: [CommonModule]
})
export class TermsOfUseModule {}
